'use strict';

import { isElement, forEach } from 'lodash';
import containerManager from '../01-helpers/filter-context/container-manager';
import { SEARCH_CLICKED } from '../02-const/event-names';
import { subscribe } from '../01-helpers/event-manager/index';

/* ========================================================================== */

const moduleName = 'teetime',
	selectors = {
		base: `.js-${moduleName}`,
	},
	className = 'collapse';

/* ========================================================================== */

function bindEvents() {
	subscribe(SEARCH_CLICKED, toggleHero.bind(this));
}

function toggleHero() {
	const $baseElement = $(this.baseElement);

	$baseElement.hasClass(className) ? null : $baseElement.addClass(className);
}

/* ========================================================================== */

export class Teetime {
	constructor(baseElement) {
		this._configure(baseElement);
		this._setup();
	}

	_configure(baseElement) {
		if (!isElement(baseElement)) {
			return false;
		}

		this.baseElement = baseElement;
		this.filterContext = containerManager.getContainer();
	}

	_setup() {
		bindEvents.call(this);
	}
}

/* ========================================================================== */

const initTeetime = () => {
	forEach(document.querySelectorAll(selectors.base), (teetimeElement) => {
		new Teetime(teetimeElement);
	});
};

initTeetime();
